export default {
  CALCULATOR_CHANGE_CURRENCY: 'vue.calculator.currency.changed',
}
